import React from 'react'
import ContentLoader from 'react-content-loader'
import { isRtl } from 'utils/uiHelpers'

const UserInfoLoader = () => (
  <ContentLoader
    rtl={isRtl}
    speed={5}
    width={373}
    height={82}
    viewBox="0 0 373 82"
    backgroundColor="#f3f3f3"
    foregroundColor="#ecebeb"
  >
    <circle
      cx="32"
      cy="32"
      r="32"
    />
    <rect
      x="78"
      y="23"
      rx="6"
      ry="6"
      width="172"
      height="18"
    />
  </ContentLoader>
)

export default UserInfoLoader
